import {CONDENSED_FOOTER, Divider, Footer as MDSFooter} from '@mds/mds-reactjs-library'
import {useMemo} from 'react'
import {FormattedMessage} from 'react-intl'

const FIXED_ELEMENTS_LINKS = [
  {
    label: <FormattedMessage id="tou" />,
    href: 'https://www.mckinsey.com/terms-of-use'
  },
  {
    label: <FormattedMessage id="privacy.policy" />,
    href: 'https://www.mckinsey.com/solutions-privacy-statement'
  }
]

const Footer = () => {
  const linksConfig = useMemo(() => {
    const externalAppLinks = [
      ...(window.czConfig.GREEN_WAVE_LINK
        ? [
            {
              label: <FormattedMessage id="links.gw" />,
              href: window.czConfig.GREEN_WAVE_LINK
            }
          ]
        : [])
    ]

    const divider = externalAppLinks.length ? [{component: Divider}] : []

    return [...externalAppLinks, ...divider, ...FIXED_ELEMENTS_LINKS]
  }, [])

  // @ts-expect-error label can also be a component
  return <MDSFooter linksConfig={linksConfig} type={CONDENSED_FOOTER} />
}

export default Footer
